module.exports = __webpack_public_path__ + "static/media/ht.89d4687b.png";